// «5 / 8» nishoni — sukut ko'rinish NECHTA qatorni yashirganini aytadi
// (ADR-033 §5).
//
// ⚠️ NEGA UMUMAN KERAK. Yashirish qarori panelniki: server parametrsiz
// hammasini qaytaradi. Ya'ni ekranda hech qanday belgi bo'lmasa,
// ro'yxatning torayganini KO'RSATADIGAN narsa yo'q — operator yopilgan
// yozuvni «o'chib ketgan» deb o'qirdi. Bu qoidaning eng qimmat yon
// ta'siri va u aynan shu yerda to'xtatiladi.
//
// Sonlar `useClosedHidden` da o'lchanadi.

import { Button, Space, Tag, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import type { ClosedHidden } from './useClosedHidden'

/**
 * Nishon va BIR BOSISHLIK yo'l.
 *
 * ⚠️ Yo'lsiz nishon holatni faqat e'lon qilardi. Yopilgan yozuvni
 * ko'rish uchun operator tanlagichni topib, ro'yxatni ochib, kerakli
 * bandni izlashi kerak bo'lardi — nishonni ko'rgan odamning savoli esa
 * bitta: «qolganini ko'rsat».
 *
 * ⚠️ Yashiringan qator bo'lmasa nishon UMUMAN chizilmaydi: «0 yashirin»
 * degan doimiy yozuv shovqin bo'lardi va vaqt o'tib ko'rinmay qolardi.
 *
 * <h2>⚠️ YORLIQ ALMASHTIRILISHI MUMKIN — chunki CHIQISH YO'LI hamma
 * joyda bir xil emas</h2>
 * Beshta sahifada holat tanlagichida «Barcha holatlar» bandi bor va
 * tugma aynan shuni bosadi. Abonentlar ro'yxatida esa bunday band
 * YO'Q: u yerda `includeClosed` faqat `state=CLOSED` bilan yoqiladi
 * (`subscriberListParams`), ya'ni bir bosish «yopilganlarni
 * ko'rsatadi», «hammasini» emas. O'sha ekranda «Barcha holatlar» deb
 * yozish tugma qiladigan ishdan BOSHQA narsani va'da qilardi.
 *
 * ⚠️ Sukut qiymat O'ZGARMADI: `showAllLabel` berilmasa avvalgidek
 * `dataTable.stateAll` chiziladi, ya'ni mavjud beshta sahifa
 * tegilmagan.
 */
export function ClosedHiddenTag({
  counts,
  onShowAll,
  showAllLabel,
}: {
  counts: ClosedHidden | null
  onShowAll: () => void
  showAllLabel?: string
}) {
  const { t } = useTranslation()
  if (counts === null || counts.hidden <= 0) return null

  return (
    <Space size={4}>
      <Tooltip title={t('dataTable.closedHiddenHint')}>
        <Tag color="blue">
          {t('dataTable.shownOfTotal', {
            shown: counts.shown,
            total: counts.shown + counts.hidden,
          })}
        </Tag>
      </Tooltip>
      <Button size="small" type="link" onClick={onShowAll}>
        {showAllLabel ?? t('dataTable.stateAll')}
      </Button>
    </Space>
  )
}
